import Link from 'next/link';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { IPage } from 'shared/types/Page';
import { variableFontRegular } from 'styles/theme/text';
import { UnorderedList } from 'shared/components/UnorderedList';

interface ITermNavItem {
  href: string;
  isActive: boolean;
  label: string;
}

const TermNavItem = ({ href, isActive, label }: ITermNavItem) => {
  return (
    <Link href={href} passHref legacyBehavior>
      <TermNavItem.Href $isActive={isActive}>{label}</TermNavItem.Href>
    </Link>
  );
};

export const TermsAndPolicyNavigation = ({ pages }: { pages: IPage[] }) => {
  const router = useRouter();
  const {
    query: { pageSlug },
  } = router;

  return (
    <TermsAndPolicyNavigation.List>
      {pages?.map((item) => (
        <TermNavItem
          key={item?.link}
          href={`/${item?.slug}`}
          isActive={pageSlug === item?.slug}
          label={item?.link}
        />
      ))}
    </TermsAndPolicyNavigation.List>
  );
};

TermNavItem.Href = styled.a<{ $isActive: boolean }>`
  ${variableFontRegular({ size: '11.5px', height: '18px' })};
  ${({ $isActive }) => $isActive && `text-decoration: underline;`}

  &:hover {
    text-decoration: underline;
  }
`;

TermsAndPolicyNavigation.List = styled(UnorderedList)`
  display: none;
  flex-direction: column;
  left: 32px;
  margin-right: 24%;
  position: absolute;
  top: 32px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    display: flex;
  }
`;
